import { Link } from "react-router-dom";

export const CadenceFooter = () => (
  <footer className="relative z-10 border-t border-[#AEE6D5]/15 bg-[#0A2E2C] px-6 pb-24 pt-12 text-center sm:px-10 sm:pb-12" data-testid="cadence-footer">
    <p className="font-serif text-lg italic text-[#AEE6D5]">Casey&#39;s Cadence</p>
    <p className="mt-2 font-mono text-[0.62rem] uppercase tracking-[0.24em] text-[#F8FAFC]/55">
      Restoring Rhythm. Reclaiming Rest. Rebuilding Teams.
    </p>
    <p className="mx-auto mt-4 max-w-xl text-xs leading-relaxed text-[#F8FAFC]/45">
      Keynote speaker &amp; rhythm-based workshops for mental health providers, community organizations,
      nonprofits, schools, and corporate teams.
    </p>
    <p className="mt-4 font-mono text-[0.58rem] uppercase tracking-[0.2em] text-[#F8FAFC]/35">
      © {new Date().getFullYear()} Casey Muze
      <span className="mx-2 text-[#F8FAFC]/20">·</span>
      <Link to="/corporate" className="transition-colors hover:text-[#AEE6D5]" data-testid="footer-corporate-link">Corporate Teams</Link>
      <span className="mx-2 text-[#F8FAFC]/20">·</span>
      <Link to="/login" className="transition-colors hover:text-[#AEE6D5]" data-testid="footer-admin-link">Admin</Link>
    </p>
  </footer>
);
